import { activityHistoryFiltersSlice } from "../slice";

export const { resetFilters } = activityHistoryFiltersSlice.actions;
